import { render, staticRenderFns } from "./SysRole.vue?vue&type=template&id=639900a7&scoped=true&"
import script from "./SysRole.vue?vue&type=script&lang=js&"
export * from "./SysRole.vue?vue&type=script&lang=js&"
import style0 from "./SysRole.vue?vue&type=style&index=0&id=639900a7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "639900a7",
  null
  
)

export default component.exports